import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, input, output, viewChildren } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { OrderData } from '@lfw/roesberg.liveforms.core';
import { TranslatePipe } from '@ngx-translate/core';
import { OpenInNewTabDirective } from '../../../route/open-in-new-tab.directive';
import { MenuVerticalDividerComponent } from '../../../shared/components/menu-vertical-divider.component';
import { OrderDetailsDialogComponent } from '../../components/order-details-dialog/order-details-dialog.component';

@Component({
  selector: 'lfw-online-order-list-actions',
  templateUrl: './online-order-list-actions.component.html',
  styleUrls: ['./online-order-list-actions.component.scss'],
  imports: [
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    TranslatePipe,
    RouterModule,
    MenuVerticalDividerComponent,
    MatTooltipModule,
    OpenInNewTabDirective
  ]
})
export class OnlineOrdersListActionsComponent {
  readonly order = input.required<OrderData>();
  readonly userCanCancel = input.required();

  readonly finishOrder = output<OrderData>();
  readonly checkoutOrder = output<OrderData>();
  readonly cancelOrder = output<OrderData>();

  readonly menuTriggers = viewChildren(MatMenuTrigger);

  private readonly breakpointObserver = inject(BreakpointObserver);
  private readonly dialog = inject(MatDialog);

  constructor() {
    this.breakpointObserver
      .observe(`(width >= 48rem)`)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.menuTriggers().forEach((trigger) => trigger.closeMenu());
      });
  }

  openOrderInformation(): void {
    const selectedOrder = this.order();

    const dialogRef = this.dialog.open(OrderDetailsDialogComponent, {
      panelClass: 'order-details-dialog-panel',
      disableClose: true
    });

    dialogRef.componentRef?.setInput('order', selectedOrder);
    this.menuTriggers().forEach((trigger) => trigger.closeMenu());
  }
}
